export default __webpack_public_path__ + "static/media/Ann_Piper_Speaker_Card.f335518c.jpg";